<template>
    <!-- ==================== 申请试用弹窗 ==================== -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="dh-apply-dialog"
      append-to-body="true"
      width="480px"
      title="联系我们"
      @closed="resetApplyForm"
    >
      <div class="dh-apply">
        <p class="dh-apply__desc">
          请填写以下信息，我们的销售顾问将尽快与您联系
        </p>
        <el-form
          ref="applyForm"
          :model="form"
          :rules="rules"
          label-position="top"
          class="dh-apply__form"
        >
          <el-form-item label="姓名" prop="customerName">
            <el-input
              v-model="form.customerName"
              placeholder="请输入姓名"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              v-model="form.companyName"
              placeholder="请输入公司名称"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系电话"
              maxlength="20"
            />
          </el-form-item>
          <el-form-item label="获悉渠道" prop="channel">
            <el-select
              v-model="form.channel"
              placeholder="请选择获悉渠道"
              class="dh-apply__select"
            >
              <el-option
                v-for="item in channelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input
              v-model="form.email"
              placeholder="请输入电子邮箱"
              maxlength="100"
            />
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input
              v-model="form.position"
              placeholder="请输入职位"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="需求说明" prop="demandDesc">
            <el-input
              v-model="form.demandDesc"
              type="textarea"
              :rows="3"
              placeholder="请简单描述您的需求（选填）"
              maxlength="500"
            />
          </el-form-item>
          <el-form-item class="dh-apply__footer">
            <button
              type="button"
              class="dh-apply__btn"
              :disabled="applySubmitting"
              @click="handleSubmit"
            >
              {{ applySubmitting ? '提交中…' : '提交信息' }}
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
</template>

<script>
import { addCustomerMessage } from '@/api/customerMessage'

export default {
  name: 'TrialApplyDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 留言来源：1-产品介绍页(/sphere-intro) 2-数字人广场 4-数字人介绍页
    source: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      applySubmitting: false,
      form: {
        customerName: '',
        companyName: '',
        phone: '',
        channel: '',
        email: '',
        position: '',
        demandDesc: ''
      },
      rules: {
        customerName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^[0-9+\-\s]{5,20}$/,
            message: '请输入正确的联系电话',
            trigger: 'blur'
          }
        ],
        channel: [
          { required: true, message: '请选择获悉渠道', trigger: 'change' }
        ],
        email: [
          { type: 'email', message: '请输入正确的电子邮箱', trigger: 'blur' }
        ]
      },
      channelOptions: [
        { value: 1, label: '官网' },
        { value: 2, label: '搜索引擎' },
        { value: 3, label: '同事推荐' },
        { value: 4, label: '行业活动' },
        { value: 5, label: '社交媒体' },
        { value: 6, label: '其他' }
      ]
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    resetApplyForm() {
      this.form = {
        customerName: '',
        companyName: '',
        phone: '',
        channel: '',
        email: '',
        position: '',
        demandDesc: ''
      }
      if (this.$refs.applyForm) {
        this.$refs.applyForm.clearValidate()
      }
    },
    handleSubmit() {
      this.$refs.applyForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.applySubmitting = true
        const payload = {
          customerName: this.form.customerName.trim(),
          position: this.form.position.trim(),
          companyName: this.form.companyName.trim(),
          phone: this.form.phone.trim(),
          email: this.form.email.trim(),
          channel: Number(this.form.channel),
          demandDesc: this.form.demandDesc.trim()
        }
        // 留言来源：1-产品介绍页 2-数字人广场 4-数字人介绍页；未指定时不传该字段
        if (this.source !== null) {
          payload.source = Number(this.source)
        }
        addCustomerMessage(payload)
          .then(() => {
            this.$message.success('提交成功，我们的销售顾问将尽快与您联系')
            this.dialogVisible = false
            this.resetApplyForm()
          })
          .catch((err) => {
            console.log(err)
            this.$message.error((err && err.message) || '提交失败，请稍后重试')
          })
          .then(() => {
            this.applySubmitting = false
          })
      })
    }
  }
}
</script>

<style lang="scss">
/* 申请试用弹窗 */
.dh-apply-dialog {
  border-radius: 12px;
  overflow: hidden;
  .el-dialog__body {
    padding: 8px 32px 32px;
  }
}
.dh-apply__desc {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 20px;
  color: #5a6a85;
}
.dh-apply__form {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__label {
    font-size: 14px;
    font-weight: 500;
    color: #0e1a2b;
    line-height: 20px;
    padding-bottom: 8px;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 42px;
    line-height: 42px;
  }
  .el-textarea__inner {
    border-radius: 8px;
    padding: 10px 12px;
    font-family: inherit;
  }
}
.dh-apply__select {
  width: 100%;
}
.dh-apply__footer {
  margin-bottom: 0 !important;
  padding-top: 4px;
}
.dh-apply__btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #2b5bff 0%, #4a5ff3 100%);
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.88;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
